import React from 'react';
import css from './css.less';
import { Tag } from 'src/components/Antd';
import GlobalTooltip from 'src/components/GlobalTooltip/GlobalTooltip';
import _ from 'lodash';
interface IProps {
  tags: { name: string; [propsName: string]: any }[];
  characterLength: number;
  containerWidth: number;
  marginPaddingWidth: number;
  containPaddingWidth: number;
  tagGenerator?: any;
  closable?: boolean;
  onClose?: (index) => void;
  tagClassName?: string;
}
const tagsGenerator = (
  originalTags,
  characterLength = 8,
  containerWidth,
  marginPaddingWidth,
  containPaddingWidth = 20,
) => {
  const tags = _.cloneDeep(originalTags || []).map((i) => {
    return { ...i, last: false };
  });

  let flageText = 0;
  let pre = 0;

  for (const current of tags) {
    const { name } = current;
    const stringfy = name.toString();

    if (
      pre + marginPaddingWidth + stringfy.length * characterLength >
      containerWidth - containPaddingWidth
    ) {
      flageText = Math.floor(
        (pre +
          marginPaddingWidth +
          stringfy.length * characterLength -
          (containerWidth - containPaddingWidth)) /
          characterLength,
      );
      current.last = true;
      break;
    }
    pre += marginPaddingWidth + stringfy.length * characterLength;
  }
  // console.log('tags, flageText', tags, flageText);

  return { tags, flageText };
  //   tags.forEach((current, index) => {

  //   });
  //   return (

  //   );
};
const TagsGroup = (props: IProps) => {
  const {
    tags,
    characterLength,
    containerWidth,
    marginPaddingWidth,
    containPaddingWidth,
    tagGenerator,
    onClose,
    closable,
    tagClassName,
  } = props;

  const { tags: calculatedTags, flageText } = React.useMemo(() => {
    return tagsGenerator(
      tags,
      characterLength,
      containerWidth,
      marginPaddingWidth,
      containPaddingWidth,
    );
  }, [tags, containerWidth]);
  const defaultGenerator = (tags) => {
    let flag = false;

    return (
      <div className={css.tags}>
        {tags.map((item, index) => {
          const { last, name } = item;
          const stringfy = name.toString();
          if (!flag) {
            const len = stringfy.length;
            let _index = len - flageText;
            if (_index < 0) {
              _index = 0;
            }
            // let
            // if (flageText > len){}else{}

            const processName = last
              ? `${stringfy.substring(0, _index)}...`
              : stringfy;

            const displayName = (
              <GlobalTooltip key={index} title={stringfy}>
                <Tag
                  color='#eeeeee'
                  className={css.grayTags + ' ' + tagClassName || ''}
                  {...(closable && { closable, onClose })}>
                  {processName}
                </Tag>
              </GlobalTooltip>
            );
            if (item.last) {
              flag = true;
            }
            return displayName;
          } else {
            return null;
          }
        })}
      </div>
    );
  };

  return tagGenerator ? (
    tagGenerator(calculatedTags)
  ) : (
    <div className={css.tags}>{defaultGenerator(calculatedTags)}</div>
  );
};
const WrappedTagsGroup = (props) => {
  const {
    tags,
    closable,
    tagClassName,
    onClose,
    suffixPart,
    containerClassName,
  } = props;

  return (
    <div className={css.wrappedTags + ' ' + containerClassName || ''}>
      {tags.map((item, index) => {
        const { name } = item;
        return (
          <GlobalTooltip key={index} title={name}>
            <Tag
              aria-label={name}
              data-index={index}
              color='#eeeeee'
              className={css.grayTags + ' ' + tagClassName || ''}
              {...(closable && {
                closable,
                onClose: (e) => {
                  e.preventDefault();
                  if (onClose) onClose(index);
                },
              })}>
              <span className={css.name}>{name}</span>
            </Tag>
          </GlobalTooltip>
        );
      })}
      {suffixPart || null}
    </div>
  );
};
export { WrappedTagsGroup };
export default TagsGroup;
// example
//   const containerWidth = useSelector(
//     (state) => state.mainLayout.contentContainerWidth,
//   );
//   const tagsContainerWidth = (containerWidth || 0) * 0.6;

//   const characterLength = 8;
//   const marginPaddingWidth = 36;
//   const containPaddingWidth = 20;
// <TagsGroup
//           tagClassName={css.tagClassName}
//           characterLength={characterLength}
//           containerWidth={tagsContainerWidth}
//           marginPaddingWidth={marginPaddingWidth}
//           containPaddingWidth={containPaddingWidth}
//           closable
//           onClose={(e) => {
//             console.log(e);
//           }}
//           tags={tags.map((i) => {
//             return { name: i };
//           })}
//         />
